import Sidebar from './sidebar_container';

export default Sidebar;